import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TrnsKeyInfo } from 'app/core/models/slice/com/trnsKeyInfo'

const initialState: TrnsKeyInfo = {
    secureKeypad1: null,
    secureKeypad2: null,
    secureKeypad3: null,
    secureKeypad4: null,
    pwdDatakey: '', // 비밀번호 Datakey
    cashPwdDatakey: '', //현금카드비밀번호 Datakey
    outPwdDatakey: '', //출금계좌 비밀번호 Datakey
    tranPwdDatakey: '', //자동이체계좌 Datakey
    pinPwdDatakey: '', //PIN비밀번호 Datakey
}

const slice = createSlice({
    name: 'trnsKeyInfo',
    initialState,
    reducers: {
        clearTrnsKeyInfo: () => initialState,
        setTrnsKeyInfos: (_state, action: PayloadAction<TrnsKeyInfo>) => {
            return action.payload
        },
        setTrnsKeyInfo: (
            state,
            action: PayloadAction<Partial<TrnsKeyInfo>>
        ) => {
            Object.entries(action.payload).forEach(([key, value]) => {
                state[key] = value
            })
        },
    },
})

export const { clearTrnsKeyInfo, setTrnsKeyInfo, setTrnsKeyInfos } =
    slice.actions

export default slice.reducer
